import { Spinner as SpinnerComponent, Box } from '@salecycle/ui-component-library';

function Spinner() {
  return (
    <Box verticalPositioning="center" horizontalPositioning="center" data-testid="Spinner">
      <SpinnerComponent />
    </Box>
  );
}

export default Spinner;
